import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentScheduleItems = new CRUD('tournament-schedule-items', 'superior-judge')

export default Object.assign(
    tournamentScheduleItems,
    {
        reducers: {
            ...tournamentScheduleItems.reducers,
            moveToSuccess: (state, action) => {
                state.isLoading = false;
            },
        },

        moveTo: (id, position) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-schedule-items/${id}/move-to/${position}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        groupMoveTo: (id, position) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-schedule-items/${id}/group-move-to/${position}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        groupChangeSchedule: (id, id_schedule) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-schedule-items/${id}/group-change-schedule/${id_schedule}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        remove: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-schedule-items/${id}/remove`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        removeGroup: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-schedule-items/${id}/remove-group`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        edit: (id, data) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-schedule-items/${id}/edit`, data)
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
